<h1 mat-dialog-title>Crea un nuovo prodotto</h1>
<div mat-dialog-content style="height: 135px">
  Quest'operazione non è reversibile, si consiglia di usarla con cautela, in quanto nessuno degli utenti potrà più sfruttare i crediti acquistati in caso di eliminazione forzata.
  <div mat-dialog-actions>
    <button  mat-button [mat-dialog-close]="true" (click)="onYesClick()">Conferma</button>
    <button mat-button (click)="onNoClick()">Cancella</button>
  </div>
</div>
